function VerifiedNotification() {
  this.queueNoty = "verifiedNotification";
}

VerifiedNotification.prototype.showNotification = function (text1, text2) {
  if (typeof text1 === "undefined" && typeof text2 === "undefined") {
    return;
  }

  // Monta e exibe a notificação de que um player que foi kickado de um Lobby por não ser Elite
  new Noty({
    // Estilos e Configurações
    queue: this.queueNoty,
    type: this.queueNoty,
    timeout: 5000,
    layout: "topRight",
    animation: {
      open: "animated fadeInRight",
      close: "animated fadeOutRight",
    },

    // Conteúdos
    text1: text1 || '',
    text2: text2 || '',
    ctaText: i18n.verified_notification_cta,
    ctaLink: "https://verificado.gamersclub.com.br/",
    ctaDataLayer: "lobby_verified_kicked",

    // Template
    callbacks: {
      onShow: function () {
        var closeButton = document.getElementsByClassName('noty_close_button')[0];
        closeButton.setAttribute("data-test", "button:close_noty");
      },
      onTemplate: function () {
        var innerHTML = '<div class="notyVerified noty_body">';
        innerHTML += '<div class="notyVerified__content">';
        innerHTML +=
          '<img src="https://static.gamersclub.com.br/assets/verified.svg" class="notyVerified__image" />';
        innerHTML += '<span class="notyVerified__line"></span>';
        innerHTML +=
          '<div class="notyVerified__text">' + this.options.text1 + "</div>";
        innerHTML +=
          '<div class="notyVerified__text">' + this.options.text2 + "</div>";
        innerHTML += "</div>"; // notyElite__content
        innerHTML += '<a target="_blank" class="notyVerified__cta"';
        innerHTML += ' href="' + this.options.ctaLink + '" ';
        innerHTML += ' data-test="button:noty_open_verified" ';
        innerHTML +=
          "onclick=\"dataLayer.push({'event': " +
          this.options.ctaDataLayer +
          '})" >';
        innerHTML += this.options.ctaText + "</a>";
        innerHTML += "</div>"; // notyVerified

        this.barDom.innerHTML = innerHTML;
      },
    },
  }).show();
};

window.verifiedNotification = new VerifiedNotification();
